import { render, staticRenderFns } from "./JournalSender.vue?vue&type=template&id=780180f0"
import script from "./JournalSender.vue?vue&type=script&lang=js"
export * from "./JournalSender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports